import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class JobRoleUtilsService {

    private readonly MAX_DISPLAY_LENGTH = 40;

    /**
     * Truncates a job role name if it exceeds the maximum display length
     * @param roleName - The job role name to truncate
     * @returns The truncated role name with ellipsis if needed
     */
    truncateJobRoleName(roleName: string): string {
        if (!roleName) return '';

        if (roleName.length <= this.MAX_DISPLAY_LENGTH) {
            return roleName;
        }

        return roleName.substring(0, this.MAX_DISPLAY_LENGTH) + '...';
    }

    /**
     * Checks if a job role name needs to be truncated
     * @param roleName - The job role name to check
     * @returns True if the role name needs truncation
     */
    needsTruncation(roleName: string): boolean {
        if (!roleName) return false;
        return roleName.length > this.MAX_DISPLAY_LENGTH;
    }

    /**
     * Gets the full job role name for tooltip display
     * @param roleName - The job role name
     * @returns The full role name or empty string if null/undefined
     */
    getFullJobRoleName(roleName: string): string {
        return roleName || '';
    }

    /**
     * Gets the maximum display length for job role names
     * @returns The maximum display length
     */
    getMaxDisplayLength(): number {
        return this.MAX_DISPLAY_LENGTH;
    }
} 